import { render, staticRenderFns } from "./b-menu-item-bubble.vue?vue&type=template&id=a8d81c26&scoped=true&"
import script from "./b-menu-item-bubble.vue?vue&type=script&lang=js&"
export * from "./b-menu-item-bubble.vue?vue&type=script&lang=js&"
import style0 from "./b-menu-item-bubble.vue?vue&type=style&index=0&id=a8d81c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d81c26",
  null
  
)

export default component.exports